const DECORATION_COLORS = new Set([
    'teal',
    'pink',
    'orange',
    'green',
    'neutral',
    'gold',
    'lime',
    'blue',
    'indigo',
    'purple',
    'magenta',
]);
const TEXT_COLOR_CLASSES = {
    default: 'text-primary',
    defaultInverted: 'text-inverse',
    light: 'text-secondary ',
    ultraLight: 'text-tertiary',
    caution: 'text-negative-primary',
    super: 'text-super-primary',
    white: 'text-white',
    positive: 'text-positive-primary',
    negative: 'text-negative-primary',
    warning: 'text-warning-primary',
    max: 'text-super-primary',
    'finance-positive': 'text-finance-positive-primary',
    'finance-negative': 'text-finance-negative-primary',
};
export function isDecorationColor(color) {
    return !!color && DECORATION_COLORS.has(color);
}
export function loaderColorClass(color) {
    if (!color || isDecorationColor(color))
        return undefined;
    return TEXT_COLOR_CLASSES[color];
}
export function loaderColorStyle(color) {
    if (!isDecorationColor(color))
        return undefined;
    return { color: `var(--decoration-${color}-fg-primary)` };
}
export function textBlockColor(color) {
    if (!color || isDecorationColor(color))
        return 'default';
    return color;
}
//# sourceMappingURL=types.js.map